(() => {
  const root = document.querySelector('[data-gallery]');
  if (!root) return;

  const cards = root.querySelector('[data-cards]'),
        select = root.querySelector('[data-product]'),
        search = root.querySelector('[data-search]'),
        more = root.querySelector('[data-more]'),
        previous = root.querySelector('[data-previous]'),
        status = root.querySelector('[data-status]'),
        dialog = root.querySelector('dialog');

  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const sent = new Set();
  function emit(name, data = {}, once = false) {
    if (!allowed() || (once && sent.has(name))) return;
    sent.add(name);
    const properties = {experiment:'real_life_gallery_v1', ...data};
    window.Shopify?.analytics?.publish?.(name, properties);
    if (typeof window.gtag === 'function') window.gtag('event', name, properties);
    if (window.Shopify?.customerPrivacy?.marketingAllowed?.() === true && typeof window.fbq === 'function') window.fbq('trackCustom', name, properties);
  }
  const announce = () => emit('proof_page_view', {}, true);
  document.addEventListener('visitorConsentCollected', announce);
  window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], announce);
  announce();

  let products = [], rows = [], filtered = [], shown = 0, opener;
  let galleryPage = 0;
  const compactGallery = window.matchMedia('(max-width:700px)');
  let demoObserver;
  const demoStops = new Set();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  reducedMotion.addEventListener('change', () => { if (reducedMotion.matches) demoStops.forEach(stop => stop()); });

  const storyNav = root.querySelector('.story-nav');
  const storyLinks = [...storyNav.querySelectorAll('a[href^="#"]')];
  const activeMarker = document.createElement('span');
  activeMarker.className = 'story-nav__active-marker';
  activeMarker.setAttribute('aria-hidden', 'true');
  storyNav.append(activeMarker);
  let activeLink, navFrame = 0, pendingLink, initialAnchorHandled = false;

  function activateStory(link, reveal = true) {
    if (!link) return;
    if (activeLink !== link) {
      activeLink?.classList.remove('is-active');
      activeLink?.removeAttribute('aria-current');
      activeLink = link;
      link.classList.add('is-active');
      link.setAttribute('aria-current', 'location');
    }
    activeMarker.style.width = `${link.offsetWidth}px`;
    activeMarker.style.height = `${link.offsetHeight}px`;
    activeMarker.style.transform = `translate3d(${link.offsetLeft}px, ${link.offsetTop}px, 0)`;
    if (!storyNav.dataset.activeReady) requestAnimationFrame(() => { storyNav.dataset.activeReady = 'true'; });
    if (reveal) {
      const center = link.offsetLeft + link.offsetWidth / 2 - storyNav.clientWidth / 2;
      if (link.offsetLeft < storyNav.scrollLeft + 40 || link.offsetLeft + link.offsetWidth > storyNav.scrollLeft + storyNav.clientWidth - 40) {
        storyNav.scrollTo({left: Math.max(0, center), behavior: reducedMotion.matches ? 'auto' : 'smooth'});
      }
    }
  }

  function updateActiveStory() {
    navFrame = 0;
    const threshold = storyNav.getBoundingClientRect().bottom + 135;
    if (pendingLink) {
      const pendingSection = document.getElementById(pendingLink.hash.slice(1));
      if (pendingSection && Math.abs(pendingSection.getBoundingClientRect().top - threshold) < 120) pendingLink = null;
      else return;
    }
    let current = storyLinks[0];
    for (const link of storyLinks) {
      const section = document.getElementById(link.hash.slice(1));
      if (section && section.getBoundingClientRect().top <= threshold) current = link;
      else break;
    }
    activateStory(current);
  }

  const scheduleActiveStory = () => { if (!navFrame) navFrame = requestAnimationFrame(updateActiveStory); };
  storyLinks.forEach(link => link.addEventListener('click', () => {
    activateStory(link);
    pendingLink = link;
    if (link.hash === '#all-photographs') loadArchiveData();
    setTimeout(() => { if (pendingLink === link) { pendingLink = null; scheduleActiveStory(); } }, 4000);
  }));

  window.addEventListener('scroll', scheduleActiveStory, {passive:true});
  window.addEventListener('resize', scheduleActiveStory);
  window.addEventListener('wheel', () => { pendingLink = null; }, {passive:true});
  window.addEventListener('touchstart', () => { pendingLink = null; }, {passive:true});
  window.addEventListener('hashchange', () => {
    const link = storyLinks.find(item => item.hash === location.hash);
    if (link) activateStory(link);
    if (location.hash === '#all-photographs') loadArchiveData();
    setTimeout(scheduleActiveStory, 120);
  });

  const sized = (url, width) => {
    try {
      const u = new URL(url);
      u.searchParams.set('width', width);
      return u.href;
    } catch {
      return url;
    }
  };
  const el = (tag, text, className) => {
    const n = document.createElement(tag);
    if (text) n.textContent = text;
    if (className) n.className = className;
    return n;
  };

  function photo(url, label, title, eager, id) {
    const wrap = el('div', '', 'photo'), button = el('button'), img = el('img');
    button.type = 'button'; button.setAttribute('aria-label', `Enlarge ${label}: ${title}`);
    img.src = sized(url, 520);
    img.srcset = `${sized(url,260)} 260w, ${sized(url,520)} 520w, ${sized(url,800)} 800w`;
    img.sizes = '(max-width:650px) 44vw, 23vw';
    img.width = 600; img.height = 800; img.alt = `${label}: ${title}`;
    img.loading = eager ? 'eager' : 'lazy';
    img.decoding = 'async';
    button.append(img);
    wrap.append(el('span', label), button);
    button.addEventListener('click', () => {
      opener = button;
      const full = dialog.querySelector('img');
      full.src = sized(button.dataset.url, 1600);
      full.alt = img.alt;
      dialog.querySelector('[data-caption]').textContent = img.alt;
      dialog.showModal();
      emit('comparison_image_view', {product_id: id, image_type: label});
    });
    button.dataset.url = url;
    return {wrap, button, img};
  }

  function linkFor(handle, variantId) {
    const url = new URL(`${root.dataset.root}products/${handle}`, location.origin);
    if (variantId) url.searchParams.set('variant', variantId);
    for (const [k, v] of new URL(location.href).searchParams) {
      if (/^utm_/.test(k) || ['fbclid','gclid','ad_id','adset_id','campaign_id','preview_theme_id','pb','_fd'].includes(k)) {
        url.searchParams.set(k, v);
      }
    }
    if (!url.searchParams.has('utm_campaign')) url.searchParams.set('utm_campaign', 'real_life_proof');
    if (!url.searchParams.has('utm_content')) url.searchParams.set('utm_content', 'all_dress_gallery_v1');
    return url.href;
  }

  // Hydrate all SSR-rendered comparison stories
  function hydrateStories() {
    demoObserver?.disconnect();
    demoStops.forEach(stop => stop());
    demoStops.clear();
    demoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.dispatchEvent(new Event('fr:demonstrate'));
    }), {threshold: .55});

    const storyElements = root.querySelectorAll('.dress-story');
    storyElements.forEach((story, index) => {
      const compare = story.querySelector('.story-compare');
      if (!compare) return;
      const website = compare.querySelector('.reveal-image');
      let websiteLayer = website?.parentElement;
      if (website && !websiteLayer?.classList.contains('reveal-layer')) {
        websiteLayer = el('div', '', 'reveal-layer');
        website.replaceWith(websiteLayer);
        websiteLayer.append(website);
      }
      const line = compare.querySelector('.reveal-line');
      const slider = compare.querySelector('input[type="range"]');
      const productId = compare.dataset.productId;
      const startPosition = Number(compare.dataset.start || 50);

      const position = value => {
        slider.value = String(value);
        if (websiteLayer) websiteLayer.style.clipPath = `inset(0 ${100 - Number(value)}% 0 0)`;
        if (line) line.style.left = `${value}%`;
      };
      position(startPosition);

      let frame = 0, demonstrated = false, interacted = false;
      const stop = () => { cancelAnimationFrame(frame); frame = 0; };
      demoStops.add(stop);

      for (const event of ['pointerdown', 'keydown', 'focus']) {
        slider.addEventListener(event, () => { interacted = true; stop(); });
      }
      slider.addEventListener('input', () => { interacted = true; stop(); position(slider.value); });

      compare.addEventListener('fr:demonstrate', () => {
        if (demonstrated || interacted || reducedMotion.matches) return;
        demonstrated = true;
        const start = performance.now();
        const tick = now => {
          const progress = Math.min((now - start) / 4200, 1);
          position(startPosition + (startPosition === 18 ? 6 : 12) * Math.sin(progress * 2 * Math.PI));
          if (progress < 1 && !interacted && !reducedMotion.matches) frame = requestAnimationFrame(tick);
          else { frame = 0; if (!interacted) position(startPosition); }
        };
        frame = requestAnimationFrame(tick);
      });
      demoObserver.observe(compare);

      // Enlarge buttons
      story.querySelectorAll('.story-enlarge').forEach(button => {
        button.addEventListener('click', () => {
          opener = button;
          const full = dialog.querySelector('img');
          const url = button.dataset.url;
          const title = button.dataset.title || '';
          full.src = sized(url, 1600);
          full.alt = title;
          dialog.querySelector('[data-caption]').textContent = title;
          dialog.showModal();
          emit('comparison_image_view', {product_id: productId, image_type: button.dataset.enlarge === 'website' ? 'View website photo' : 'View customer photo'});
        });
      });

      // Story shop CTA tracking and query parameter synchronization
      const shop = story.querySelector('.story-shop');
      if (shop) {
        // Sync any incoming UTM / tracking query params to the CTA href
        try {
          const u = new URL(shop.href, location.origin);
          for (const [k, v] of new URL(location.href).searchParams) {
            if (/^utm_/.test(k) || ['fbclid','gclid','ad_id','adset_id','campaign_id','preview_theme_id','pb','_fd'].includes(k)) {
              u.searchParams.set(k, v);
            }
          }
          shop.href = u.href;
        } catch {}

        shop.addEventListener('click', () => {
          emit('proof_cta_click', {product_id: productId, position: index + 1, placement: 'featured_story'});
        });
      }
    });

    if (!initialAnchorHandled && location.hash) {
      const link = storyLinks.find(item => item.hash === location.hash);
      const section = link && document.getElementById(link.hash.slice(1));
      if (section) {
        initialAnchorHandled = true;
        activateStory(link);
        requestAnimationFrame(() => {
          window.scrollTo({top: window.scrollY + section.getBoundingClientRect().top - storyNav.offsetHeight - 18, behavior: 'instant'});
          scheduleActiveStory();
        });
      }
    }
    scheduleActiveStory();
  }

  // Customer archive photo cards logic
  function append() {
    const pageSize = compactGallery.matches ? 8 : 16;
    const start = galleryPage * pageSize;
    const batch = filtered.slice(start, start + pageSize), fragment = document.createDocumentFragment();
    cards.replaceChildren();
    batch.forEach(({p, photo: item}, index) => {
      const article = el('article', '', 'pair customer-card');
      article.dataset.productId = p.id;
      article.dataset.file = item.file;
      const customer = photo(item.url, 'Customer photograph', p.title, false, p.id);
      customer.wrap.querySelector('span')?.remove();
      article.append(customer.wrap);

      const position = start + index + 1;
      const a = el('a', '');
      a.className = 'archive-shop';
      const title = el('span', 'Shop This Dress →');
      title.className = 'archive-shop__title';
      a.append(title);
      const detail = el('p', 'See available colors, sizes & delivery details');
      detail.className = 'archive-shop-note';
      a.href = linkFor(p.handle, p.variant_id);
      a.addEventListener('click', () => emit('proof_cta_click', {product_id: p.id, position}));
      article.append(a, detail);
      fragment.append(article);
    });
    cards.append(fragment);
    shown = start + batch.length;
    more.hidden = shown >= filtered.length;
    previous.hidden = galleryPage === 0;
    status.textContent = filtered.length ? `Customer photographs ${start + 1}–${shown} of ${filtered.length}` : 'No photographs match this search.';
  }

  function filter() {
    const q = search.value.trim().toLowerCase();
    filtered = rows.filter(x => (!select.value || x.p.id === select.value) && x.p.title.toLowerCase().includes(q));
    shown = 0;
    galleryPage = 0;
    cards.replaceChildren();
    append();
  }

  select.addEventListener('change', filter);
  search.addEventListener('input', filter);
  more.addEventListener('click', () => { galleryPage++; append(); cards.scrollIntoView({block: 'start'}); });
  previous.addEventListener('click', () => { galleryPage = Math.max(0, galleryPage - 1); append(); cards.scrollIntoView({block: 'start'}); });
  compactGallery.addEventListener('change', filter);
  root.querySelector('[data-reset]')?.addEventListener('click', () => { select.value = ''; search.value = ''; filter(); });

  root.querySelector('[data-close]')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => opener?.focus());

  function applyEdits() {
    const edits = new Map([...document.querySelectorAll('[data-photo-edit]')].map(n => [n.dataset.file, n.dataset.image]));
    products.forEach(p => p.photos.forEach(photo => {
      photo.originalUrl ||= photo.url;
      photo.url = edits.get(photo.file) || photo.originalUrl;
    }));
    document.querySelectorAll('[data-hero-file]').forEach(img => {
      img.dataset.originalSrc ||= img.src;
      img.dataset.originalSrcset ||= img.srcset;
      const override = edits.get(img.dataset.heroFile);
      if (override) {
        img.src = sized(override, 320);
        img.srcset = `${sized(override, 240)} 240w, ${sized(override, 360)} 360w, ${sized(override, 480)} 480w`;
      } else {
        if (img.src !== img.dataset.originalSrc) img.src = img.dataset.originalSrc;
        img.srcset = img.dataset.originalSrcset;
      }
    });
  }

  let archiveLoaded = false, archiveLoading = false;
  function loadArchiveData() {
    if (archiveLoaded || archiveLoading) return;
    archiveLoading = true;
    fetch(root.dataset.source)
      .then(r => { if (!r.ok) throw Error('Gallery unavailable'); return r.json(); })
      .then(data => {
        products = data;
        archiveLoaded = true;
        archiveLoading = false;
        applyEdits();
        products.forEach(p => {
          const option = el('option', `${p.title} (${p.photos.length})`);
          option.value = p.id;
          select.append(option);
        });
        const longest = Math.max(...products.map(p => p.photos.length));
        for (let i = 0; i < longest; i++) {
          products.forEach(p => { if (p.photos[i]) rows.push({p, photo: p.photos[i]}); });
        }
        filter();
      })
      .catch(() => {
        archiveLoading = false;
        status.textContent = 'The photograph gallery could not load. Please refresh, or contact us for help viewing a dress.';
      });
  }

  // Defer archive load until scrolled near or requested
  const archiveObserver = new IntersectionObserver(entries => {
    if (entries.some(e => e.isIntersecting)) {
      loadArchiveData();
      archiveObserver.disconnect();
    }
  }, {rootMargin: '600px'});

  const archiveEl = root.querySelector('#all-photographs');
  if (archiveEl) archiveObserver.observe(archiveEl);

  // Fallback idle load after 4 seconds
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => loadArchiveData(), {timeout: 4000});
  } else {
    setTimeout(loadArchiveData, 4000);
  }

  // Immediately hydrate server-rendered stories!
  hydrateStories();

  document.addEventListener('shopify:section:load', () => {
    hydrateStories();
    if (archiveLoaded) { applyEdits(); filter(); }
  });
})();
